import { adminAPIService } from './index'

const route = 'affiliates'

export default {
  getAffiliateList: () => adminAPIService({
    url: `${route}`,
    method: 'get',
  }),
}
